module.exports = __webpack_public_path__ + "img/orion-banner-new.5870e984.gif";